import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b4a6e20"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "product-discount position-absolute small p-1 px-2 deep-orange text-white"
}
const _hoisted_2 = { class: "product-image-wrap position-relative" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "py-1 px-2 product-info bg-cyan-light w-100" }
const _hoisted_6 = {
  style: {"-webkit-line-clamp":"1"},
  class: "text-dark text-claim font-weight-bold text-uppercase small"
}
const _hoisted_7 = { class: "wrap-product-name" }
const _hoisted_8 = {
  style: {"-webkit-line-clamp":"3"},
  class: "text-dark text-claim font-weight-normal small product-name"
}
const _hoisted_9 = { class: "font-weight-bold deep-orange-text mb-1" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "font-weight-bold" }, "S/ ", -1))
const _hoisted_11 = {
  key: 0,
  class: "text-strike ml-2 grey-text"
}
const _hoisted_12 = { class: "d-flex small" }
const _hoisted_13 = { class: "text-dark" }
const _hoisted_14 = { class: "text-dark ml-auto" }
const _hoisted_15 = { class: "text-muted" }
const _hoisted_16 = {
  key: 0,
  class: "bg-white"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_countdown = _resolveComponent("vue-countdown")!
  const _component_ColorOptionCarousel = _resolveComponent("ColorOptionCarousel")!

  return (_ctx.product)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "product-thumb bg-white text-justify",
        style: {"top":"0","bottom":"0"},
        onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hover = true)),
        onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hover = false))
      }, [
        _createElementVNode("div", {
          class: "position-relative d-block pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToDetail()))
        }, [
          (_ctx.product.percent)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, "% " + _toDisplayString(_ctx.product.percent), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            (!_ctx.hover)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "product-image position-absolute h-100 w-100 p-3",
                  style: {"padding-top":"2.5rem"},
                  src: this.thumb,
                  alt: "thumbnail"
                }, null, 8, _hoisted_3))
              : _createCommentVNode("", true),
            (_ctx.hover)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  class: "product-image position-absolute h-100 w-100 p-3",
                  style: {"padding-top":"2.5rem"},
                  src: this.thumb,
                  alt: "thumbnail"
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.product.brand), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h6", _hoisted_8, _toDisplayString(_ctx.product.name), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("h5", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("span", null, _toDisplayString(_ctx.decimalsPrice(_ctx.price)), 1),
                (_ctx.strike)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_11, _toDisplayString(_ctx.strike), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString((_ctx.product.sold === 1)? _ctx.product.sold + ' vendido' : _ctx.product.sold + ' vendidos'), 1),
              _createElementVNode("div", _hoisted_14, [
                (_ctx.time > 0)
                  ? (_openBlock(), _createBlock(_component_vue_countdown, {
                      key: 0,
                      time: _ctx.time
                    }, {
                      default: _withCtx(({ days, hours, minutes, seconds }) => [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(days) + "d", 1),
                        _createTextVNode(" " + _toDisplayString((hours<10)? '0'+hours : hours) + ":" + _toDisplayString((minutes<10)? '0'+minutes : minutes) + ":" + _toDisplayString((seconds<10)? '0'+seconds : seconds), 1)
                      ]),
                      _: 1
                    }, 8, ["time"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]),
        (_ctx.hover && _ctx.colors && _ctx.colors.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(_component_ColorOptionCarousel, {
                slug: _ctx.product.slug,
                thumb: _ctx.product.thumb,
                colors: _ctx.colors,
                onChangePreview: _ctx.updatePreview
              }, null, 8, ["slug", "thumb", "colors", "onChangePreview"])
            ]))
          : _createCommentVNode("", true)
      ], 32))
    : _createCommentVNode("", true)
}